export const blockStyles = [
  {
    blockStyleName: 'Title 1',
    cameCaseName: 'title1'
  },
  {
    blockStyleName: 'Title 2',
    cameCaseName: 'title2'
  },
  {
    blockStyleName: 'Title 3',
    cameCaseName: 'title3'
  },
  {
    blockStyleName: 'Headline',
    cameCaseName: 'headline'
  },
  {
    blockStyleName: 'Body',
    cameCaseName: 'body'
  },
  {
    blockStyleName: 'Subhead',
    cameCaseName: 'subhead'
  },
  {
    blockStyleName: 'Footnote',
    cameCaseName: 'footnote'
  },
  {
    blockStyleName: 'Caption 1',
    cameCaseName: 'caption1'
  },
  {
    blockStyleName: 'Caption 2',
    cameCaseName: 'caption2'
  },
]

export const weights = [
  {
    name: 'Default',
    class: '',
  },
  {
    name: 'Light',
    class: 'light',
  },
  {
    name: 'Regular',
    class: 'regular',
  },
  {
    name: 'Bold',
    class: 'bold',
  }
]


export const draftJSInlineStyles = {
  'primary': {
    color: 'rgb(var(--ts-color-primary))',
  },
  'accent': {
    color: 'rgb(var(--ts-color-accent))',
  },
  'textSecondary': {
    color: 'rgba(var(--ts-color-text-secondary), var(--ts-color-text-secondary-alpha))',
  },
  'readOnly': {
    color: 'rgba(var(--ts-color-read-only), var(--ts-color-read-only-alpha))',
  },
  'positive': {
    color: 'rgb(var(--ts-color-positive))',
  },
  'negative': {
    color: 'rgb(var(--ts-color-negative))',
  },
  'informative': {
    color: 'rgb(var(--ts-color-informative))',
  },
  'notice': {
    color: 'rgb(var(--ts-color-notice))',
  },

  'bold': {
    fontWeight: 'var(--ts-font-weight-bold)'
  },
  'regular': {
    fontWeight: 'var(--ts-font-weight-regular)'
  },
  'light': {
    fontWeight: 'var(--ts-font-weight-light)'
  },

}


export const colorStyles = [
  {
    colorName: 'Default',
    inlineStyle: 'rgba(var(--ts-color-text-primary), var(--ts-color-text-primary-alpha))',
    nameCamel: 'textPrimary',
    colorVariable: 'text-primary'
  },
  {
    colorName: 'Primary',
    inlineStyle: 'rgb(var(--ts-color-primary))',
    nameCamel: 'primary',
    colorVariable: 'primary'
  },
  {
    colorName: 'Accent',
    inlineStyle: 'rgb(var(--ts-color-accent))',
    nameCamel: 'accent',
    colorVariable: 'accent'
  },
  {
    colorName: 'Text Secondary',
    inlineStyle: 'rgba(var(--ts-color-text-secondary), var(--ts-color-text-secondary-alpha))',
    nameCamel: 'textSecondary',
    colorVariable: 'text-secondary'
  },
  {
    colorName: 'Read Only',
    inlineStyle: 'rgba(var(--ts-color-read-only), var(--ts-color-read-only-alpha))',
    nameCamel: 'readOnly',
    colorVariable: 'read-only'
  },
  {
    colorName: 'Positive',
    inlineStyle: 'rgb(var(--ts-color-positive))',
    nameCamel: 'positive',
    colorVariable: 'positive'
  },
  {
    colorName: 'Negative',
    inlineStyle: 'rgb(var(--ts-color-negative))',
    nameCamel: 'negative',
    colorVariable: 'negative'
  },
  {
    colorName: 'Informative',
    inlineStyle: 'rgb(var(--ts-color-informative))',
    nameCamel: 'informative',
    colorVariable: 'informative'
  },
  {
    colorName: 'Notice',
    inlineStyle: 'rgb(var(--ts-color-notice))',
    nameCamel: 'notice',
    colorVariable: 'notice'
  },
]
